export enum AppSyncSteps {
  ENTER_ACCOUNT_INFO = 'enterAccountInfo',
  ASSIGN_LICENSE = 'assignLicense',
  SELECT_LOCATION = 'selectLocation',
  CONFIRM_2FA = 'confirm2fa',
  SYNCHRONIZING = 'synchronizing',
  SYNC_ERROR = 'syncError',
  SYNCHRONIZATION_SUCCESSFUL = 'synchronizationSuccessful',
}

export enum SyncProcessingStatuses {
  PROCESSING = 'processing',
  TWO_FA = '2fa',
  CAPTCHA = 'captcha',
  CHOOSE_CONTRACT = 'chooseContract',
  THIRD_PARTY = 'thirdParty',
  THIRD_PARTY_TEXT = 'thirdPartyText',
}

export enum AppSyncErrors {
  WRONG_CREDENTIALS = 'wrongCredentials',
  WRONG_PIN = 'wrongPin',
  TIMED_OUT_CAPTCHA = 'timedOutCaptcha',
  ONBOARDING_INCOMPLETE = 'onboardingIncomplete',
  TWO_FA_NOT_ENABLED = 'twoFaNotEnabled',
  CONNECTIVITY_COOLDOWN = 'connectivityCooldown',
  LOGIN_EXPIRED = 'loginExpired',
  UNKNOWN = 'unknown',
}

/**
 * Vier gezählte Schritte: Produkt & Sitz, Zugangsdaten, Standort, Verbinden.
 *
 * Die Lizenz steht vorn, nicht hinter den Zugangsdaten. Vorher tippte der Kunde erst
 * LinkedIn-Adresse und Passwort ein und erfuhr danach, dass kein Sitz frei ist. Die
 * Reihenfolge fragt jetzt zuerst nach dem, was fehlschlagen kann, bevor jemand ein
 * Passwort eingibt.
 *
 * Der Standort ist ein eigener Schritt, weil er nicht mehr nur ein Proxy-Feld ist: das
 * Konto bekommt dort seine eigene feste IP. Angelegt wird deshalb am Ende dieses
 * Schrittes — in einem Aufruf, der Lizenz, Zugangsdaten und Standort zusammen mitschickt.
 *
 * Die Warnung von damals gilt weiter, nur an anderer Stelle: wer hier bloß den
 * Schrittzähler erhöht, ohne dass irgendein Schritt danach wirklich anlegt, landet auf
 * dem Verbinden-Bildschirm und wartet für immer.
 */
export const stepOrder = [
  AppSyncSteps.ASSIGN_LICENSE,
  AppSyncSteps.ENTER_ACCOUNT_INFO,
  AppSyncSteps.SELECT_LOCATION,
  AppSyncSteps.SYNCHRONIZING,
  AppSyncSteps.SYNCHRONIZATION_SUCCESSFUL,
];

/** „Fertig" trägt keine Zählung mehr — der Fortschritt endet bei „Verbinden". */
export const countedStepCount = stepOrder.length - 1;
